// import remarkGfm from "remark-gfm";
// import rehypeHighlight from "rehype-highlight";
import ReactMarkdown from "react-markdown";
import React from "react";
import {message} from "antd";
import remarkGfm from 'https://esm.sh/remark-gfm@4'
import rehypeHighlight from 'https://esm.sh/rehype-highlight@7.0.1'
import "highlight.js/styles/atom-one-dark.css";
import './index.css'
//remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeHighlight]}
const MarkDownApp = (props)=>{
    const {value} = props
    const handleCopyCode = async(id)=>{
        const text = document.getElementById(id).innerText;
        await navigator.clipboard.writeText(text);
        message.success('复制成功')
    }
    const showValue = value?value.replace(/`/g, '"').replaceAll('. ','.&nbsp;'):value
    return (
        <div className={'markDownApp'} >
            <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeHighlight]} components={{
                    pre: ({ children }) => <pre className="not-prose">{children}</pre>,
                code:({node, className, children, ...props})=>{
                    const match = /language-(\w+)/.exec(className || "");
                    if (match?.length) {
                        const id = Math.random().toString(36).substr(2, 9);
                        const lan = match.toString().split(',')[0]
                        return (
                            <code className={`hljs ${lan} `}>
                                <div className={'copyCode'}>
                                    <span onClick={()=>handleCopyCode(id)}>复制代码</span>
                                </div>
                                <div id={id} >
                                    {children}
                                </div>
                            </code>
                        );
                    } else {
                        return (
                            <div>
                                <code className={`language-bash`}
                                    {...props}
                                >
                                    {children}
                                </code>
                            </div>

                        );
                    }

                }
                }}

            >
                {showValue?showValue.toString().replace(/"""/g,'```'):showValue}
            </ReactMarkdown>
        </div>

    )
}
export default MarkDownApp
